import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { SEO } from "@/components/SEO";
import Home from "@/pages/Home";
import RestaurantPage from "@/pages/RestaurantPage";
import Constitution from "@/pages/Constitution";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

const LenisProvider = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LenisProvider>
          <ScrollManager />
          <SEO />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/constitutie" element={<Constitution />} />
            <Route path="/:slug" element={<RestaurantPage />} />
          </Routes>
        </LenisProvider>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
